module.exports = __webpack_public_path__ + "media/images/flags/co-85d4f5d2443429b67a3a229bb80dae62.svg";